"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BeeDev = void 0;
const cafe_utility_1 = require("cafe-utility");
const _1 = require(".");
const connectivity_1 = require("./modules/debug/connectivity");
const http_1 = require("./utils/http");
class BeeDev extends _1.Bee {
    async getNodeAddresses(options) {
        const requestOptions = super.getRequestOptionsForCall(options);
        const response = await (0, http_1.http)(requestOptions, {
            url: 'addresses',
            responseType: 'json',
        });
        const body = cafe_utility_1.Types.asObject(response.data, { name: 'response.data' });
        return {
            overlay: new _1.PeerAddress(cafe_utility_1.Types.asString(body.overlay, { name: 'overlay' })),
            underlay: [],
            ethereum: new _1.EthAddress(cafe_utility_1.Types.asString(body.ethereum, { name: 'ethereum' })),
            publicKey: new _1.PublicKey(cafe_utility_1.Types.asString(body.publicKey, { name: 'publicKey' })),
            pssPublicKey: new _1.PublicKey(cafe_utility_1.Types.asString(body.pssPublicKey, { name: 'pssPublicKey' })),
        };
    }
    async getTopology(options) {
        const requestOptions = super.getRequestOptionsForCall(options);
        const response = await (0, http_1.http)(requestOptions, {
            url: `topology`,
            responseType: 'json',
        });
        const body = cafe_utility_1.Types.asObject(response.data, { name: 'response.data' });
        const bins = cafe_utility_1.Types.asObject(body.bins, { name: 'bins' });
        return {
            baseAddr: '0bab5ca208a980950604f900f2791613fc980676c2dee7dd92a4fdda5a54bf26',
            population: cafe_utility_1.Types.asNumber(body.population, { name: 'population' }),
            connected: cafe_utility_1.Types.asNumber(body.connected, { name: 'connected' }),
            timestamp: cafe_utility_1.Types.asString(body.timestamp, { name: 'timestamp' }),
            nnLowWatermark: cafe_utility_1.Types.asNumber(body.nnLowWatermark, { name: 'nnLowWatermark' }),
            depth: cafe_utility_1.Types.asNumber(body.depth, { name: 'depth' }),
            reachability: 'Public',
            networkAvailability: 'Available',
            bins: {
                bin_0: (0, connectivity_1.asBin)(bins.bin_0, 'bin_0'),
                bin_1: (0, connectivity_1.asBin)(bins.bin_1, 'bin_1'),
                bin_2: (0, connectivity_1.asBin)(bins.bin_2, 'bin_2'),
                bin_3: (0, connectivity_1.asBin)(bins.bin_3, 'bin_3'),
                bin_4: (0, connectivity_1.asBin)(bins.bin_4, 'bin_4'),
                bin_5: (0, connectivity_1.asBin)(bins.bin_5, 'bin_5'),
                bin_6: (0, connectivity_1.asBin)(bins.bin_6, 'bin_6'),
                bin_7: (0, connectivity_1.asBin)(bins.bin_7, 'bin_7'),
                bin_8: (0, connectivity_1.asBin)(bins.bin_8, 'bin_8'),
                bin_9: (0, connectivity_1.asBin)(bins.bin_9, 'bin_9'),
                bin_10: (0, connectivity_1.asBin)(bins.bin_10, 'bin_10'),
                bin_11: (0, connectivity_1.asBin)(bins.bin_11, 'bin_11'),
                bin_12: (0, connectivity_1.asBin)(bins.bin_12, 'bin_12'),
                bin_13: (0, connectivity_1.asBin)(bins.bin_13, 'bin_13'),
                bin_14: (0, connectivity_1.asBin)(bins.bin_14, 'bin_14'),
                bin_15: (0, connectivity_1.asBin)(bins.bin_15, 'bin_15'),
                bin_16: (0, connectivity_1.asBin)(bins.bin_16, 'bin_16'),
                bin_17: (0, connectivity_1.asBin)(bins.bin_17, 'bin_17'),
                bin_18: (0, connectivity_1.asBin)(bins.bin_18, 'bin_18'),
                bin_19: (0, connectivity_1.asBin)(bins.bin_19, 'bin_19'),
                bin_20: (0, connectivity_1.asBin)(bins.bin_20, 'bin_20'),
                bin_21: (0, connectivity_1.asBin)(bins.bin_21, 'bin_21'),
                bin_22: (0, connectivity_1.asBin)(bins.bin_22, 'bin_22'),
                bin_23: (0, connectivity_1.asBin)(bins.bin_23, 'bin_23'),
                bin_24: (0, connectivity_1.asBin)(bins.bin_24, 'bin_24'),
                bin_25: (0, connectivity_1.asBin)(bins.bin_25, 'bin_25'),
                bin_26: (0, connectivity_1.asBin)(bins.bin_26, 'bin_26'),
                bin_27: (0, connectivity_1.asBin)(bins.bin_27, 'bin_27'),
                bin_28: (0, connectivity_1.asBin)(bins.bin_28, 'bin_28'),
                bin_29: (0, connectivity_1.asBin)(bins.bin_29, 'bin_29'),
                bin_30: (0, connectivity_1.asBin)(bins.bin_30, 'bin_30'),
                bin_31: (0, connectivity_1.asBin)(bins.bin_31, 'bin_31'),
            },
        };
    }
}
exports.BeeDev = BeeDev;
